const GLOBAL_ADDRESSES_OPTIONS = {
  organization_country: 'Organization Country',
  all: 'International',
  multiple: 'Multiple Countries',
} as const;

export default GLOBAL_ADDRESSES_OPTIONS;
